import { render, staticRenderFns } from "./CollectionFilterControlTypeNumber.vue?vue&type=template&id=19112d4a"
import script from "./CollectionFilterControlTypeNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeNumber.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports